import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-busyable-button',
    templateUrl: './busyable-button.component.html',
    styleUrls: ['./busyable-button.component.scss'],
    standalone: false
})
export class BusyableButtonComponent {
    @Input() type = 'submit';
    @Input() disabled = false;
    @Input() busy = false;
    @Input() text!: string;

    constructor() {}
}
